var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-condition-value"},[_c('a-spin',{attrs:{"spinning":_vm.usersInfoService.isLoading}},[_c('black-white-list-tags',{attrs:{"values":_vm.model.values,"formatter":_vm.format}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }